import inputMachine from './machines/inputMachine'
import selectMachine from './machines/selectMachine'

export const INPUT = 'input'
export const SELECT = 'select'
export const subMachines = {
  [INPUT]: inputMachine,
  [SELECT]: selectMachine,
}
